module.exports = "/_next/static/images/OgAI-ad9f64911c803f4d6d33ec8ab256d6ff.png";